export const DashboardStaticData = {
  dashboardText: 'Dashboard',
};

export const DashboardHindiData = {
  dashboardText: 'डैशबोर्ड',
};

export const DashboardArabicData = {
  dashboardText: 'لوحة التحكم',
};
